import axios from "../axiosHelper";
import Cookies from "js-cookie";

export default {
  state: {
    status: "",
    status_code: "",
    message: "",
    message_code: "",
    user: {},
    userClassList: [{}],
    userList: [{}],
    genderList: [{}],
    userTypeList: [{}],
    classesList: [{}],
    userActivityList: [],
    userModulMonitoringList: [],
    userAbsenceList: [],
    userSettingList: [],
    taList: [],
  },
  getters: {
    getUser: (state) => state.user,
    getUserActivityList: (state) => state.userActivityList,
    getUserModulMonitoringList: (state) => state.userModulMonitoringList,
    getUserClassList: (state) => state.userClassList,
    getUserClassListCombineTa: (state) => state.userClassList,
    getUserSettingList: (state) => state.userSettingList,
    getUserList: (state) => state.userList,
    getTaList: (state) => state.taList,
    getUserAbsenceList: (state) => state.userAbsenceList,
    getUserTypeList: (state) => state.userTypeList,
    getClassesList: (state) => state.classesList,
  },
  mutations: {
    request(state) {
      state.status = "LOADING";
    },
    success(state, { resp }) {
      state.status = "SUCCESS";
      if (resp) {
        state.status_code = resp.data.status;
        state.message = resp.data.message;
        state.message_code = resp.data.code;
      }
    },
    error(state, { resp }) {
      state.status = "ERROR";
      if (resp) {
        state.status_code = resp.data.status;
        state.message = resp.data.message;
        state.message_code = resp.data.code;
      }
    },
    setUser(state, { resp }) {
      if (resp) {
        state.user = resp.data.data;
      }
    },
    setUserActivityList(state, { resp }) {
      if (resp) {
        state.userActivityList = resp.data.data;
      } else {
        state.userActivityList = [{}];
      }
    },
    setUserModulMonitoringList(state, { resp }) {
      if (resp) {
        state.userModulMonitoringList = resp.data.data;
      } else {
        state.userModulMonitoringList = [{}];
      }
    },
    setUserClassList(state, { resp }) {
      if (resp) {
        state.userClassList = resp.data.data;
      } else {
        state.userClassList = [{}];
      }
    },
    setUserAbsenceList(state, { resp }) {
      if (resp) {
        state.userAbsenceList = resp.data.data;
      } else {
        state.userAbsenceList = [{}];
      }
    },
    setUserSettingList(state, { resp }) {
      if (resp) {
        state.userSettingList = resp.data.data;
      } else {
        state.userSettingList = [{}];
      }
    },
    setUserList(state, { resp }) {
      if (resp) {
        state.userList = resp.data.data;
      }
    },
    setTaList(state, { resp }) {
      if (resp) {
        state.taList = resp.data.data;
      }
    },
    setUserTypeList(state, { resp }) {
      if (resp) {
        state.userTypeList = resp.data.data;
      }
    },
    setClassList(state, { resp }) {
      if (resp) {
        state.classesList = resp.data.data;
      }
    },
  },
  actions: {
    importUserData({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/import-user?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
          headers: {
            "content-type": "multipart/form-data",
          },
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getUser({ commit }) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/my/profile?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setUser", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getUserById({ commit }, userId) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/formulir-pendaftaran/detail/" + userId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setUser", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getUserTypeList({ commit }) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/get-type?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setUserTypeList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getClassesList({ commit }) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/get-class?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setClassList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    changePassword({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/my/change-password?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    saveProfile({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/my/profile?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    saveSosmed({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/my/sosmed?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    saveUserAddress({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/my/address?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    saveUserOrtu({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/my/ortu?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    saveUserIjazah({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/my/ijazah?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    saveUserPindahan({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/my/pindahan?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    saveUserDiterima({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/my/diterima?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    saveFotoProfile({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/upload/upload-profile?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
          headers: {
            "content-type": "multipart/form-data",
          },
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    saveTtd({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/upload/upload-ttd?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
          headers: {
            "content-type": "multipart/form-data",
          },
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getUserActivityList({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-activity/" + param.userId + "/" + param.startDate + "/" + param.endDate + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setUserActivityList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getUserModulMonitoringList({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v2/user-material-monitoring/" + param.taId + "/" + param.classId + "/" + param.subjectId + "/" + param.laId + "/" + param.modulId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setUserModulMonitoringList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getUserClassList({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-activity/user-class-list/" + param.userId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setUserClassList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getUserClassListCombineTa({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-activity/user-class-list-combineta/" + param.userId + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setUserClassList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getUserSettingList({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/" + param.type + "/" + param.status + "/" + param.class_id + "/" + param.ta_id + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setUserSettingList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getUserList({ commit }) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-activity/user-list?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setUserList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getTaList({ commit }) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/ta-list?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setTaList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    getUserAbsenceList({ commit }, param) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/absences/" + param.classId + "/" + param.taId + "/" + param.semester + "/" + param.subjectId + "/" + param.startDate + "/" + param.endDate + "?token=" + Cookies.get("token"),
          method: "GET",
        })
          .then((resp) => {
            commit("success", { resp });
            commit("setUserAbsenceList", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    deleteUser({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/delete?token=" + Cookies.get("token"),
          data: form,
          isMultiple: "0",
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    resetPasswordUser({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/reset-password?token=" + Cookies.get("token"),
          data: form,
          isMultiple: "0",
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    deleteMultipleUser({ commit }, data) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/delete?token=" + Cookies.get("token"),
          data: data,
          isMultiple: "1",
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    activationMultipleUser({ commit }, data) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/is-active?token=" + Cookies.get("token"),
          data: data,
          isMultiple: "1",
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    naikKelas({ commit }, data) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/naik-kelas?token=" + Cookies.get("token"),
          data: data,
          isMultiple: "1",
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    updateUser({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/edit?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
    addUser({ commit }, form) {
      return new Promise(function (resolve, reject) {
        commit("request");
        axios({
          url: "/v1/user-management/add?token=" + Cookies.get("token"),
          data: form,
          method: "POST",
        })
          .then((resp) => {
            commit("success", { resp });
            resolve(resp);
          })
          .catch((err) => {
            let resp = err.response;
            commit("error", { resp });
            reject(err);
          });
      });
    },
  },
};
